import { BrowserRouter, Route, Routes } from "react-router-dom";

import ProtectedRoutes from "./ProtectedRoutes/index";
import AdminPanel from "./Admin/Main/AdminPanel";
import Verify from "./Verify/Verify";
import Home from "./Home/Home";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoutes>
              <AdminPanel />
            </ProtectedRoutes>
          }
        />
        <Route path="/verify.php" element={<Verify />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
